<template>
    <div class="terms-conditions" v-html="terms">

    </div>
</template>

 
<script>
    export default{
        mounted() {
        },
        props: ['terms'],
        data(){            
            
            return {
                accept:false,
            }
        },
        methods:{
        },
    }
</script>
<style>
    .terms-conditions{
        font-family : 'arial';
    }
</style>